export default __webpack_public_path__ + "static/media/foxface.42b5204a.jpeg";